// imports
import { useRef } from "react";
import { useEffect, useState } from "react";
import { usePairingPackage  } from "../../providers/PairingPackage";
import AppSelect from "../AppSelect/AppSelect";
import "./OtherFilters.scss";
import {useTranslation} from "react-i18next";
import {matDropDownStyle} from '../../assets/style/material/matSyles';
import { useFilterPreference } from "../../providers/FilterPreference";

/** OtherFilters
 * This component contains the Other filter options for the slide out filter
 * @param param0 The props passed into this object
 * @returns the OtherFilters component
 */
export default function OtherFilters({
  displayFiltersClicked,
  setSelectedFilters,
  selectedFilters,
  setSaveFilters
}) {

  const { t } = useTranslation();
  const pairingContext = usePairingPackage();
  const dropDownClasses = matDropDownStyle();
  const filterContext = useFilterPreference();

  const [othersFilter, setOthersFilter] = useState({
    occurs: {selected: selectedFilters.selectedOthersFilter.occurs.selected, options: ['All']},
    pairType: {selected: selectedFilters.selectedOthersFilter.pairType.selected, options: ['All']},
  });

  useEffect(()=>{
    setOthersFilter({
      occurs: {...othersFilter.occurs, selected:selectedFilters.selectedOthersFilter.occurs.selected },
      pairType: {...othersFilter.pairType, selected:selectedFilters.selectedOthersFilter.pairType.selected}
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedFilters])

  const selects = useRef([])
  useEffect(() => {
    if (!pairingContext.pairingPackageData) {
      return;
    }

    let occurOptions = othersFilter.occurs.options;
    let mappedOccurOptions = pairingContext.pairingPackageData.pairingList.map(f => f.occurs).filter(f => f);

    let pairOptions = othersFilter.pairType.options;
    let mappedPairOptions = pairingContext.pairingPackageData.pairingList.map(f => f.pairType).filter(f => f);

    setOthersFilter({
      occurs: {...othersFilter.occurs, options: [...occurOptions, ...mappedOccurOptions.filter((f, i) => mappedOccurOptions.indexOf(f) === i)]},
      pairType: {...othersFilter.pairType, options: [...pairOptions, ...mappedPairOptions.filter((f, i) => mappedPairOptions.indexOf(f) === i)]}
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairingContext.pairingPackageData]);

  useEffect(() => {
    if (!displayFiltersClicked) {
      return;
    }
    let occursValue = selects.current['occurs'].querySelector('input').value;
    let pairValue = selects.current['pairType'].querySelector('input').value;
    let pairFilter = pairValue.split(',');
    let occursFilter = occursValue.split(',').map(f => parseFloat(f));
    
    // set the selected filter in pairing package scope
    setSelectedFilters((prevState) => {
      return {
        ...prevState,
        selectedOthersFilter: {
          occurs: {
            selected: occursValue.toLowerCase() !== 'all' && !!occursValue ? occursFilter : ["All"]
          },
          pairType: {
            selected: pairValue.toLowerCase() !== 'all' && !!pairValue ? pairFilter : ["All"]
          }
        }
      }
    });

    if(filterContext.defaultSearchState) setSaveFilters(true); 

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayFiltersClicked]);

  return (
    <div className="others-filter">
      <div className="others-filter-container">
        {/* Select for the Occurs filter */}
        <div className="others-filter">
          <AppSelect
            selectLabel={t('filters.other.occurs')}
            selectRef={selects}
            fillElements={othersFilter.occurs.options}
            selectedItem={othersFilter.occurs.selected}
            multiSelect={true}
            name={"occurs"}            
            selectedStyle={dropDownClasses.selectForOtherFilter}
            sort={true}
          />
        </div>

        {/* Select for the Pair Type filter */}
        <div className="others-filter">
          <AppSelect
            selectLabel={t('filters.other.pairType')}
            selectRef={selects}
            fillElements={othersFilter.pairType.options}
            selectedItem={othersFilter.pairType.selected}
            multiSelect={true}
            name={"pairType"}            
            selectedStyle={dropDownClasses.selectForOtherFilter}
          />
        </div>
      </div>
    </div>
  );
}
